// extracted by mini-css-extract-plugin
export default {"examination":"Report_examination__WtVe-","tableActions":"Report_tableActions__tP5fy"};